import heartEmpty from '@/assets/images/nps/heart-empty.svg'
import heartFilled from '@/assets/images/nps/heart-filled.svg'
import styles from './NpsScale.module.css'

interface NpsScaleProps {
  min: number
  max: number
  value: number | null
  onChange: (score: number) => void
}

/** Сколько делений считаем «широкой» шкалой: пять сердечек в макете, при
 *  переходе на 0–10 их станет одиннадцать и прежний размер не влезет. */
const WIDE_FROM = 7

/**
 * Шкала оценки. Число делений приходит снаружи: сейчас 1–5, но границы —
 * настройка бэка, и заказчик рассматривает переход на 0–10.
 */
export const NpsScale = ({ min, max, value, onChange }: NpsScaleProps) => {
  const scores = Array.from({ length: max - min + 1 }, (_, i) => min + i)
  const isWide = scores.length >= WIDE_FROM

  return (
    <div
      className={`${styles.scale} ${isWide ? styles.wide : ''}`}
      role="radiogroup"
      aria-label="Оценка"
    >
      {scores.map(score => {
        const isFilled = value !== null && score <= value
        return (
          <button
            key={score}
            type="button"
            role="radio"
            aria-checked={value === score}
            aria-label={`Оценка ${score}`}
            className={styles.item}
            onClick={() => onChange(score)}
          >
            <img
              className={styles.icon}
              src={isFilled ? heartFilled : heartEmpty}
              alt=""
            />
          </button>
        )
      })}
    </div>
  )
}
